(function() {
  const popup = document.getElementById('christmas-shutdown-popup');
  if (!popup) return;

  const closeBtn = popup.querySelector('.christmas-shutdown-popup__close');
  const dismissBtn = popup.querySelector('.christmas-shutdown-popup__dismiss');
  const overlay = popup.querySelector('.christmas-shutdown-popup__overlay');
  const STORAGE_KEY = 'christmas_shutdown_popup_dismissed';
  const DISMISSAL_DURATION = 12 * 60 * 60 * 1000; // 12 hours in milliseconds
  const END_DATE = new Date('2026-01-02T00:00:00');

  function isBeforeEndDate() {
    return new Date() < END_DATE;
  }

  function shouldShowPopup() {
    if (!isBeforeEndDate()) return false;

    const dismissedAt = localStorage.getItem(STORAGE_KEY);
    if (!dismissedAt) return true;

    const timeSinceDismissal = Date.now() - parseInt(dismissedAt, 10);
    return timeSinceDismissal > DISMISSAL_DURATION;
  }

  function dismissPopup() {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    popup.style.display = 'none';
    document.body.style.overflow = '';
  }

  function showPopup() {
    popup.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  // Show popup if conditions are met
  if (shouldShowPopup()) {
    showPopup();
  }

  // Close button click
  closeBtn.addEventListener('click', dismissPopup);

  // Dismiss button click
  dismissBtn.addEventListener('click', dismissPopup);

  // Overlay click
  overlay.addEventListener('click', dismissPopup);

  // ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.style.display === 'block') {
      dismissPopup();
    }
  });
})();
